import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const GettingAround = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddGettingAround = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditGettingAround = () => {
  return (
    
      
        <Edit />
      
    
  );
};
